import { DownIcon, UpIcon } from 'foundations-assets';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDismissedTaskCards } from 'setup-guide-components/contexts/TaskCardsContext';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompletedSectionAccordion = ({
  isExpanded,
  onClick
}) => {
  const {
    trackUserInteraction
  } = useTracker();
  const dismissedTaskCards = useDismissedTaskCards();
  if (dismissedTaskCards.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    paddingInline: "400",
    children: /*#__PURE__*/_jsx(View, {
      maxInlineSize: "400px",
      children: /*#__PURE__*/_jsxs(SelectableButton, {
        block: true,
        "data-test-id": "crm-suite-show-more-hubs",
        onClick: event => {
          onClick(event);
          const willBeExpanded = !isExpanded;
          trackUserInteraction('completed task view card section expander click', willBeExpanded ? 'open' : 'close');
        },
        truncatable: false,
        children: [isExpanded ? /*#__PURE__*/_jsx(UpIcon, {}) : /*#__PURE__*/_jsx(DownIcon, {}), /*#__PURE__*/_jsx(Text, {
          typography: "body-125",
          children: isExpanded ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "setup-guide-components.checklist.hideCompletedSections"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "setup-guide-components.checklist.showCompletedSections"
          })
        })]
      })
    })
  });
};
export default CompletedSectionAccordion;